 
import Content from "./components/Content/Content";
import IvesmenBox from "./components/IvesmentBox/IvesmentBox";


function Header() {
 
     return ( 
        <>
      <header className="hero">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 hero-content">
              <Content/>
            </div>
            <div className="col-lg-6">
               <IvesmenBox/>
            </div>
          </div>
        </div>
      </header>
     </> 
  ); 

}

export default Header;